import { jsx, jsxs } from "react/jsx-runtime";
import { P as PropTypes } from "./index-qdNxdI8l.js";
import { DesignSystemProvider } from "@quickenloans-ui-suite/design-system";
import { E as ENVIRONMENTS } from "./OffersContext-BHJzoe2E.js";
import { M as MKT_CONTAINER_BREAKPOINT, V as VARIANTS, a as MKT_CONTAINER_ID, C as CUSTOM_OFFER_CONTAINER_ID } from "./index-B6R21tiH.js";
import { d as MarketPlaceContainer, M as MarketplaceHeader, b as Offers, C as CustomOfferCard$1, O as OfferCard, a as OfferContainer, c as OffersContainer } from "./MarketplaceHeader-C0kj_a0x.js";
import { u as useMarketingClickId } from "./useMarketingClickId-DleklX1e.js";
import { M as MarketplaceProvider } from "./MarketplaceProvider-Dvw8Q1E5.js";
import "react";
import { u as useIsTestMode } from "./useIsTestMode-CiXhde60.js";
const components = {
  components: {
    MuiCssBaseline: {
      styleOverrides: (theme2) => ({})
    },
    cta: {
      width: {
        default: "100%",
        tablet: "177px",
        desktop: "179px"
      }
    }
  }
};
const containerBreakpoints = {
  breakpoints: {
    values: {
      [MKT_CONTAINER_BREAKPOINT.mobile]: 599,
      [MKT_CONTAINER_BREAKPOINT.tablet]: 600,
      [MKT_CONTAINER_BREAKPOINT.desktop]: 885
    }
  }
};
const theme = {
  ...components,
  ...containerBreakpoints
};
const Marketplace = ({
  environment = ENVIRONMENTS.PRODUCTION,
  sourceId,
  sx = {},
  defaultMarketingClickId,
  variant,
  maxOffers,
  defaultFilters,
  showHeader = true
}) => {
  const { marketingClickId } = useMarketingClickId({ defaultMarketingClickId });
  const marketplaceVariant = Object.values(VARIANTS).includes(variant) ? variant : VARIANTS.FULL;
  return /* @__PURE__ */ jsx(
    DesignSystemProvider,
    {
      appName: "marketplace",
      theme,
      shouldMergeWithBaseTheme: true,
      importCss: true,
      children: /* @__PURE__ */ jsx(MarketplaceProvider, { defaultFilters, children: /* @__PURE__ */ jsxs(
        MarketPlaceContainer,
        {
          "data-testid": `marketplace-container-${marketplaceVariant}`,
          itemScope: true,
          itemType: "https://schema.org/ItemList",
          className: `env-${environment}`,
          id: MKT_CONTAINER_ID,
          sx,
          children: [
            showHeader ? /* @__PURE__ */ jsx(MarketplaceHeader, {}) : null,
            /* @__PURE__ */ jsx(
              Offers,
              {
                marketingClickId,
                sourceId,
                environment,
                marketplaceVariant,
                maxOffers
              }
            )
          ]
        }
      ) })
    }
  );
};
const FilterPropType = PropTypes.shape({
  key: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired
});
Marketplace.propTypes = {
  environment: PropTypes.string,
  sourceId: PropTypes.string,
  defaultFilters: PropTypes.arrayOf(FilterPropType),
  sx: PropTypes.object,
  defaultMarketingClickId: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
  maxOffers: PropTypes.number
};
const CustomOfferCard = ({
  sx = {},
  environment = ENVIRONMENTS.PRODUCTION,
  id = CUSTOM_OFFER_CONTAINER_ID,
  dataTestId = "custom-offer-card",
  config,
  sourceId,
  marketingClickId,
  children
}) => {
  const isTestMode = useIsTestMode();
  return /* @__PURE__ */ jsx(
    DesignSystemProvider,
    {
      appName: "marketplace",
      theme,
      shouldMergeWithBaseTheme: true,
      importCss: true,
      children: /* @__PURE__ */ jsx(
        CustomOfferCard$1,
        {
          sx,
          environment,
          id,
          dataTestId,
          config,
          sourceId,
          marketingClickId,
          isTestMode,
          children
        }
      )
    }
  );
};
CustomOfferCard.propTypes = {
  sx: PropTypes.object,
  environment: PropTypes.string,
  id: PropTypes.string,
  dataTestId: PropTypes.string,
  config: PropTypes.shape({
    imageSrc: PropTypes.string.isRequired,
    cta: PropTypes.shape({
      redirectUrl: PropTypes.string.isRequired,
      ctaText: PropTypes.string.isRequired
    }).isRequired,
    fillColor: PropTypes.string,
    imageAlt: PropTypes.string
  }).isRequired,
  sourceId: PropTypes.string,
  marketingClickId: PropTypes.string.isRequired,
  children: PropTypes.node
};
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CustomOfferCard,
  MarketPlaceContainer,
  Marketplace,
  MarketplaceHeader,
  MarketplaceProvider,
  OfferCard,
  OfferContainer,
  Offers,
  OffersContainer,
  theme
}, Symbol.toStringTag, { value: "Module" }));
export {
  CustomOfferCard as C,
  Marketplace as M,
  index as i,
  theme as t
};
//# sourceMappingURL=index-Dum9oDc5.js.map
